import axios from 'axios';
import { dataDecrypt } from '../utils/dataDecrypt';
export const getIP = async () => {
    try {
        const { data } = await axios.get(`https://geomok.grupomok.com.co/json`);
        return dataDecrypt(data);
    } catch (error) {
        return error;
    }
};